var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93422 10.5837C7.81134 10.5837 7.70766 10.5414 7.62318 10.4569C7.5387 10.3648 7.49646 10.2573 7.49646 10.1344V8.32574H5.68782C5.56494 8.32574 5.46126 8.2835 5.37678 8.19902C5.2923 8.10686 5.25006 7.99934 5.25006 7.87646C5.25006 7.7459 5.2923 7.63838 5.37678 7.5539C5.46126 7.46942 5.56494 7.42718 5.68782 7.42718H7.49646V5.61854C7.49646 5.49566 7.5387 5.39198 7.62318 5.3075C7.70766 5.22302 7.81134 5.18078 7.93422 5.18078C8.06478 5.18078 8.1723 5.22302 8.25678 5.3075C8.34126 5.39198 8.3835 5.49566 8.3835 5.61854V7.42718H10.1921C10.315 7.42718 10.4187 7.47326 10.5032 7.56542C10.5953 7.6499 10.6414 7.75358 10.6414 7.87646C10.6414 7.99934 10.5953 8.10686 10.5032 8.19902C10.4187 8.2835 10.315 8.32574 10.1921 8.32574H8.3835V10.1344C8.3835 10.2573 8.34126 10.3648 8.25678 10.4569C8.1723 10.5414 8.06478 10.5837 7.93422 10.5837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.0f10b65b125fc6d6d3c2a6f13deee1d1.svg";
export { ForwardRef as ReactComponent };